<template>
  <div class="nav-bar">
    <ul class="nav-bar__nav-list">
      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          :class="{ active: isDashboardRoute }"
          :to="vueRoutes.dashboard"
        >
          <!--eslint-disable-->
          <svg
            width="25"
            height="23"
            viewBox="0 0 25 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.4541 13.5444C18.0009 13.5444 18.4875 13.3368 18.914 12.9215C19.3406 12.5063 19.5538 12.0218 19.5538 11.4681C19.5538 10.9356 19.3406 10.4671 18.914 10.0625C18.4875 9.65787 18.0009 9.45555 17.4541 9.45555C16.9073 9.45555 16.4206 9.65787 15.9941 10.0625C15.5676 10.4671 15.3543 10.9356 15.3543 11.4681C15.3543 12.0218 15.5676 12.5063 15.9941 12.9215C16.4206 13.3368 16.9073 13.5444 17.4541 13.5444ZM1.9685 19.3903C1.9685 19.3903 1.9685 19.6725 1.9685 20.2368C1.9685 20.8012 1.9685 21.0833 1.9685 21.0833V1.91667C1.9685 1.91667 1.9685 2.20417 1.9685 2.77917C1.9685 3.35417 1.9685 3.64167 1.9685 3.64167C1.9685 3.64167 1.9685 4.0463 1.9685 4.85556C1.9685 5.66481 1.9685 6.67639 1.9685 7.89028V15.1417C1.9685 16.3556 1.9685 17.3671 1.9685 18.1764C1.9685 18.9856 1.9685 19.3903 1.9685 19.3903ZM1.9685 23C1.46544 23 1.01159 22.8083 0.606956 22.425C0.202319 22.0417 0 21.5944 0 21.0833V1.91667C0 1.42685 0.202319 0.984954 0.606956 0.590972C1.01159 0.196991 1.46544 0 1.9685 0H21.6535C22.1785 0 22.6378 0.196991 23.0315 0.590972C23.4252 0.984954 23.622 1.42685 23.622 1.91667V6.19722H21.6535V1.91667H1.9685V21.0833H21.6535V16.8347H23.622V21.0833C23.622 21.5944 23.4252 22.0417 23.0315 22.425C22.6378 22.8083 22.1785 23 21.6535 23H1.9685ZM13.7139 17.4736C12.9703 17.4736 12.3797 17.2606 11.9423 16.8347C11.5048 16.4088 11.2861 15.8444 11.2861 15.1417V7.89028C11.2861 7.1662 11.5048 6.59653 11.9423 6.18125C12.3797 5.76597 12.9703 5.55833 13.7139 5.55833H22.5722C23.3158 5.55833 23.9064 5.76597 24.3438 6.18125C24.7813 6.59653 25 7.1662 25 7.89028V15.1417C25 15.8444 24.7813 16.4088 24.3438 16.8347C23.9064 17.2606 23.3158 17.4736 22.5722 17.4736H13.7139ZM23.0315 15.5569V7.475H13.2546V15.5569H23.0315Z"
            />
          </svg>
          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.dashboard') }}
          </span>
        </router-link>
      </li>

      <!--      <li class="nav-bar__nav-item">-->
      <!--        <router-link-->
      <!--          class="nav-bar__nav-link"-->
      <!--          :class="{ active: isWalletRoute }"-->
      <!--          :to="vueRoutes.wallet"-->
      <!--        >-->
      <!--          &lt;!&ndash;eslint-disable&ndash;&gt;-->
      <!--          <svg-->
      <!--            width="25"-->
      <!--            height="23"-->
      <!--            viewBox="0 0 25 23"-->
      <!--            fill="none"-->
      <!--            xmlns="http://www.w3.org/2000/svg"-->
      <!--          >-->
      <!--            <path-->
      <!--              d="M17.4541 13.5444C18.0009 13.5444 18.4875 13.3368 18.914 12.9215C19.3406 12.5063 19.5538 12.0218 19.5538 11.4681C19.5538 10.9356 19.3406 10.4671 18.914 10.0625C18.4875 9.65787 18.0009 9.45555 17.4541 9.45555C16.9073 9.45555 16.4206 9.65787 15.9941 10.0625C15.5676 10.4671 15.3543 10.9356 15.3543 11.4681C15.3543 12.0218 15.5676 12.5063 15.9941 12.9215C16.4206 13.3368 16.9073 13.5444 17.4541 13.5444ZM1.9685 19.3903C1.9685 19.3903 1.9685 19.6725 1.9685 20.2368C1.9685 20.8012 1.9685 21.0833 1.9685 21.0833V1.91667C1.9685 1.91667 1.9685 2.20417 1.9685 2.77917C1.9685 3.35417 1.9685 3.64167 1.9685 3.64167C1.9685 3.64167 1.9685 4.0463 1.9685 4.85556C1.9685 5.66481 1.9685 6.67639 1.9685 7.89028V15.1417C1.9685 16.3556 1.9685 17.3671 1.9685 18.1764C1.9685 18.9856 1.9685 19.3903 1.9685 19.3903ZM1.9685 23C1.46544 23 1.01159 22.8083 0.606956 22.425C0.202319 22.0417 0 21.5944 0 21.0833V1.91667C0 1.42685 0.202319 0.984954 0.606956 0.590972C1.01159 0.196991 1.46544 0 1.9685 0H21.6535C22.1785 0 22.6378 0.196991 23.0315 0.590972C23.4252 0.984954 23.622 1.42685 23.622 1.91667V6.19722H21.6535V1.91667H1.9685V21.0833H21.6535V16.8347H23.622V21.0833C23.622 21.5944 23.4252 22.0417 23.0315 22.425C22.6378 22.8083 22.1785 23 21.6535 23H1.9685ZM13.7139 17.4736C12.9703 17.4736 12.3797 17.2606 11.9423 16.8347C11.5048 16.4088 11.2861 15.8444 11.2861 15.1417V7.89028C11.2861 7.1662 11.5048 6.59653 11.9423 6.18125C12.3797 5.76597 12.9703 5.55833 13.7139 5.55833H22.5722C23.3158 5.55833 23.9064 5.76597 24.3438 6.18125C24.7813 6.59653 25 7.1662 25 7.89028V15.1417C25 15.8444 24.7813 16.4088 24.3438 16.8347C23.9064 17.2606 23.3158 17.4736 22.5722 17.4736H13.7139ZM23.0315 15.5569V7.475H13.2546V15.5569H23.0315Z"-->
      <!--            />-->
      <!--          </svg>-->
      <!--          &lt;!&ndash;eslint-enable&ndash;&gt;-->
      <!--          <span class="nav-bar__nav-link-name">-->
      <!--            {{ $t('side-bar.nav-bar.wallet-lbl') }}-->
      <!--          </span>-->
      <!--        </router-link>-->
      <!--      </li>-->
      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          active-class="nav-bar__nav-link-active"
          :class="{ active: isUsersRoute }"
          :to="vueRoutes.users"
          exact
        >
          <!--eslint-disable-->
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.4987 11.9411C10.8945 11.9411 9.58203 11.4094 8.5612 10.346C7.54036 9.28266 7.02995 7.91547 7.02995 6.24447C7.02995 4.57346 7.54036 3.20627 8.5612 2.1429C9.58203 1.07954 10.8945 0.547852 12.4987 0.547852C14.1029 0.547852 15.4154 1.07954 16.4362 2.1429C17.457 3.20627 17.9674 4.57346 17.9674 6.24447C17.9674 7.91547 17.457 9.28266 16.4362 10.346C15.4154 11.4094 14.1029 11.9411 12.4987 11.9411ZM0.832031 24.1318V20.562C0.832031 19.5999 1.06293 18.777 1.52474 18.0934C1.98654 17.4098 2.58203 16.8908 3.3112 16.5363C4.93967 15.7768 6.5013 15.2071 7.99609 14.8274C9.49089 14.4476 10.9918 14.2577 12.4987 14.2577C14.0056 14.2577 15.5004 14.4539 16.9831 14.8464C18.4657 15.2388 20.0213 15.8021 21.6497 16.5363C22.4032 16.8908 23.0108 17.4098 23.4727 18.0934C23.9345 18.777 24.1654 19.5999 24.1654 20.562V24.1318H0.832031ZM3.01953 21.8532H21.9779V20.562C21.9779 20.1569 21.8624 19.7708 21.6315 19.4036C21.4006 19.0365 21.115 18.7644 20.7747 18.5871C19.2192 17.8023 17.7973 17.2642 16.5091 16.9731C15.2209 16.6819 13.8841 16.5363 12.4987 16.5363C11.1133 16.5363 9.76432 16.6819 8.45182 16.9731C7.13932 17.2642 5.71745 17.8023 4.1862 18.5871C3.84592 18.7644 3.56641 19.0365 3.34766 19.4036C3.12891 19.7708 3.01953 20.1569 3.01953 20.562V21.8532ZM12.4987 9.66243C13.4466 9.66243 14.2305 9.33963 14.8503 8.69401C15.4701 8.04839 15.7799 7.23188 15.7799 6.24447C15.7799 5.25705 15.4701 4.44054 14.8503 3.79492C14.2305 3.14931 13.4466 2.8265 12.4987 2.8265C11.5508 2.8265 10.7669 3.14931 10.1471 3.79492C9.52734 4.44054 9.21745 5.25705 9.21745 6.24447C9.21745 7.23188 9.52734 8.04839 10.1471 8.69401C10.7669 9.33963 11.5508 9.66243 12.4987 9.66243Z"
            />
          </svg>

          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.users-lbl') }}
          </span>
        </router-link>
      </li>
      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          active-class="nav-bar__nav-link-active"
          :class="{ active: isNotariesRoute }"
          :to="vueRoutes.notaries"
          exact
        >
          <!--eslint-disable-->
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.4987 11.9411C10.8945 11.9411 9.58203 11.4094 8.5612 10.346C7.54036 9.28266 7.02995 7.91547 7.02995 6.24447C7.02995 4.57346 7.54036 3.20627 8.5612 2.1429C9.58203 1.07954 10.8945 0.547852 12.4987 0.547852C14.1029 0.547852 15.4154 1.07954 16.4362 2.1429C17.457 3.20627 17.9674 4.57346 17.9674 6.24447C17.9674 7.91547 17.457 9.28266 16.4362 10.346C15.4154 11.4094 14.1029 11.9411 12.4987 11.9411ZM0.832031 24.1318V20.562C0.832031 19.5999 1.06293 18.777 1.52474 18.0934C1.98654 17.4098 2.58203 16.8908 3.3112 16.5363C4.93967 15.7768 6.5013 15.2071 7.99609 14.8274C9.49089 14.4476 10.9918 14.2577 12.4987 14.2577C14.0056 14.2577 15.5004 14.4539 16.9831 14.8464C18.4657 15.2388 20.0213 15.8021 21.6497 16.5363C22.4032 16.8908 23.0108 17.4098 23.4727 18.0934C23.9345 18.777 24.1654 19.5999 24.1654 20.562V24.1318H0.832031ZM3.01953 21.8532H21.9779V20.562C21.9779 20.1569 21.8624 19.7708 21.6315 19.4036C21.4006 19.0365 21.115 18.7644 20.7747 18.5871C19.2192 17.8023 17.7973 17.2642 16.5091 16.9731C15.2209 16.6819 13.8841 16.5363 12.4987 16.5363C11.1133 16.5363 9.76432 16.6819 8.45182 16.9731C7.13932 17.2642 5.71745 17.8023 4.1862 18.5871C3.84592 18.7644 3.56641 19.0365 3.34766 19.4036C3.12891 19.7708 3.01953 20.1569 3.01953 20.562V21.8532ZM12.4987 9.66243C13.4466 9.66243 14.2305 9.33963 14.8503 8.69401C15.4701 8.04839 15.7799 7.23188 15.7799 6.24447C15.7799 5.25705 15.4701 4.44054 14.8503 3.79492C14.2305 3.14931 13.4466 2.8265 12.4987 2.8265C11.5508 2.8265 10.7669 3.14931 10.1471 3.79492C9.52734 4.44054 9.21745 5.25705 9.21745 6.24447C9.21745 7.23188 9.52734 8.04839 10.1471 8.69401C10.7669 9.33963 11.5508 9.66243 12.4987 9.66243Z"
            />
          </svg>
          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.notaries-lbl') }}
          </span>
        </router-link>
      </li>
      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          active-class="nav-bar__nav-link-active"
          :class="{ active: isNotaryCabinetRoute }"
          :to="vueRoutes.notaryRequests"
          exact
        >
          <!--eslint-disable-->
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 2L2 7.5V12C2 17.1 6.5 21.9 12.5 23C18.5 21.9 23 17.1 23 12V7.5L12.5 2ZM11 17L7 13L8.4 11.6L11 14.2L16.6 8.6L18 10L11 17Z"/>
          </svg>
          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.notary-cabinet-lbl') }}
          </span>
        </router-link>
      </li>
      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          :to="vueRoutes.rentalsAdmin"
          exact
        >
          <!--eslint-disable-->
          <svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 10.5L12 3L21 10.5V20C21 20.55 20.55 21 20 21H15V14H9V21H4C3.45 21 3 20.55 3 20V10.5Z" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M16.5 5.5V3.5H19V7.5" stroke-width="1.5"/>
          </svg>
          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.rentals-lbl') }}
          </span>
        </router-link>
      </li>
      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          :to="vueRoutes.topupAdmin"
          exact
        >
          <!--eslint-disable-->
          <svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3Z" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M9 8h6M9 12h6M9 16h3" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.topup-lbl') }}
          </span>
        </router-link>
      </li>
      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          :class="{ active: isRealEstateRoute }"
          :to="vueRoutes.realEstate"
        >
          <!--eslint-disable-->

          <svg
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.5 7.66667V22.5H0.5V2.875C0.5 2.24511 0.750222 1.64102 1.19562 1.19562C1.64102 0.750222 2.24511 0.5 2.875 0.5H12.4583C13.0882 0.5 13.6923 0.750222 14.1377 1.19562C14.5831 1.64102 14.8333 2.24511 14.8333 2.875V4.79167V5.29167H15.3333H20.125C20.7549 5.29167 21.359 5.54189 21.8044 5.98729C22.2498 6.43269 22.5 7.03678 22.5 7.66667ZM1.41667 21.0833V21.5833H1.91667H13.4167H13.9167V21.0833V2.875C13.9167 2.48823 13.763 2.11729 13.4895 1.8438C13.216 1.57031 12.8451 1.41667 12.4583 1.41667H2.875C2.48823 1.41667 2.11729 1.57031 1.8438 1.8438C1.57031 2.11729 1.41667 2.48823 1.41667 2.875V21.0833ZM15.3333 6.20833H14.8333V6.70833V21.0833V21.5833H15.3333H21.0833H21.5833V21.0833V7.66667C21.5833 7.27989 21.4297 6.90896 21.1562 6.63547C20.8827 6.36198 20.5118 6.20833 20.125 6.20833H15.3333ZM4.33333 12.9583H6.20833V13.875H4.33333V12.9583ZM11 12.9583V13.875H9.125V12.9583H11ZM6.20833 16.7917V17.7083H4.33333V16.7917H6.20833ZM11 16.7917V17.7083H9.125V16.7917H11ZM6.20833 6.20833H4.33333V5.29167H6.20833V6.20833ZM11 5.29167V6.20833H9.125V5.29167H11ZM6.20833 10.0417H4.33333V9.125H6.20833V10.0417ZM11 9.125V10.0417H9.125V9.125H11ZM18.6667 12.9583V13.875H17.75V12.9583H18.6667ZM18.6667 16.7917V17.7083H17.75V16.7917H18.6667ZM18.6667 9.125V10.0417H17.75V9.125H18.6667Z"
              stroke="white"
            />
          </svg>

          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.real-estate-lbl') }}
          </span>
        </router-link>
      </li>

      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          active-class="nav-bar__nav-link-active"
          :class="{ active: isContractRoute }"
          :to="vueRoutes.contracts"
        >
          <!--eslint-disable-->
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.81854 4.68172V1.27263C5.81854 0.971248 5.93826 0.682209 6.15137 0.4691C6.36448 0.25599 6.65352 0.136267 6.9549 0.136267H16.0458C16.3472 0.136267 16.6362 0.25599 16.8493 0.4691C17.0625 0.682209 17.1822 0.971248 17.1822 1.27263V4.68172H21.7276C22.029 4.68172 22.318 4.80145 22.5312 5.01455C22.7443 5.22766 22.864 5.5167 22.864 5.81809V21.7272C22.864 22.0286 22.7443 22.3176 22.5312 22.5307C22.318 22.7438 22.029 22.8635 21.7276 22.8635H1.27308C0.9717 22.8635 0.682661 22.7438 0.469552 22.5307C0.256442 22.3176 0.136719 22.0286 0.136719 21.7272V5.81809C0.136719 5.5167 0.256442 5.22766 0.469552 5.01455C0.682661 4.80145 0.9717 4.68172 1.27308 4.68172H5.81854ZM2.40945 6.95445V20.5908H20.5913V6.95445H2.40945ZM8.09126 2.40899V4.68172H14.9094V2.40899H8.09126Z"
            />
          </svg>
          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.contracts-lbl') }}
          </span>
        </router-link>
      </li>

      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          :class="{ active: isCoordinationRoute }"
          active-class="nav-bar__nav-link-active"
          :to="vueRoutes.approvals"
          exact
        >
          <!--eslint-disable-->
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.9167 24.9999H2.08333V22.9166H22.9167V24.9999ZM25 16.6666C25 14.9437 23.5979 13.5416 21.875 13.5416H16.6667C16.2458 13.5416 15.9875 13.3093 15.8698 13.1708C15.7531 13.0322 15.5687 12.7374 15.6406 12.3229C16.2437 8.85306 16.6656 5.49994 16.6656 4.16764C16.6656 1.86973 14.7969 0.000976562 12.499 0.000976562C10.201 0.000976562 8.33229 1.86973 8.33229 4.16764C8.33229 5.49785 8.75417 8.85202 9.35833 12.3229C9.43021 12.7374 9.24583 13.0322 9.12917 13.1708C9.0125 13.3093 8.75417 13.5416 8.33229 13.5416H3.125C1.40208 13.5416 0 14.9437 0 16.6666V20.8333H25V16.6666ZM2.08333 16.6666C2.08333 16.0926 2.55104 15.6249 3.125 15.6249H8.33333C9.25729 15.6249 10.1292 15.2187 10.724 14.5114C11.3187 13.8031 11.5698 12.876 11.4115 11.9645C10.8344 8.65098 10.4156 5.37077 10.4156 4.1666C10.4156 3.01764 11.35 2.08327 12.499 2.08327C13.6479 2.08327 14.5823 3.01764 14.5823 4.1666C14.5823 5.37389 14.1646 8.65306 13.5875 11.9645C13.4292 12.8749 13.6792 13.8031 14.274 14.5104C14.8698 15.2187 15.7406 15.6239 16.6656 15.6239H21.874C22.449 15.6239 22.9156 16.0916 22.9156 16.6656V18.7489H2.08333V16.6656V16.6666Z"
            />
          </svg>
          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.coordination-lbl') }}
          </span>
          <span v-if="pendingTotal > 0" class="nav-bar__count" :title="$t('side-bar.nav-bar.pending-title')">{{ pendingTotal }}</span>
        </router-link>
      </li>
      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          :class="{ active: isDaoRoute }"
          active-class="nav-bar__nav-link-active"
          :to="vueRoutes.daoAdmin"
        >
          <!--eslint-disable-->
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 2L2 7.5V12C2 17.1 6.5 21.9 12.5 23C18.5 21.9 23 17.1 23 12V7.5L12.5 2ZM11 17L7 13L8.4 11.6L11 14.2L16.6 8.6L18 10L11 17Z"/>
          </svg>
          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.dao-lbl') }}
          </span>
        </router-link>
      </li>
      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          :class="{ active: isExchangeRoute }"
          active-class="nav-bar__nav-link-active"
          :to="vueRoutes.exchangeAdmin"
        >
          <!--eslint-disable-->
          <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 8h13l-3.5-3.5M20 16H7l3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
          </svg>
          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.exchange-lbl') }}
          </span>
        </router-link>
      </li>
      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          :class="{ active: isWalletRecoveryRoute }"
          active-class="nav-bar__nav-link-active"
          :to="vueRoutes.walletRecovery"
        >
          <!--eslint-disable-->
          <svg width="20" height="25" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z"/>
          </svg>
          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.wallet-recovery-lbl') }}
          </span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { vueRoutes } from '@/router/route-const';
import api from '@/js/services/api';

export default {
  setup() {
    const route = useRoute();
    let isRealEstateRoute = computed(() => {
      return route.path.includes(vueRoutes.realEstate.name);
    });

    let isContractRoute = computed(() => {
      return route.path.includes(vueRoutes.contracts.name);
    });

    let isNotariesRoute = computed(() => {
      return route.path.includes(vueRoutes.notaries.name);
    });

    let isNotaryCabinetRoute = computed(() => {
      return route.path.includes(vueRoutes.notaryRequests.name);
    });

    let isWalletRoute = computed(() => {
      return route.path.includes(vueRoutes.wallet.name);
    });
    let isDashboardRoute = computed(() => {
      return route.path.includes(vueRoutes.dashboard.name);
    });

    let isCoordinationRoute = computed(() => {
      return route.path.includes(vueRoutes.approvals.name);
    });

    let isDaoRoute = computed(() => {
      return route.path.startsWith('/dao');
    });

    let isExchangeRoute = computed(() => {
      return route.path.startsWith('/exchange-admin');
    });

    let isWalletRecoveryRoute = computed(() => {
      return route.path.includes(vueRoutes.walletRecovery.name);
    });

    let isRealEstate = ref(false);
    let isWallet = ref(false);

    // the requests waiting in «Узгодження» (all queues), refreshed every minute
    const store = useStore();
    const pendingTotal = ref(0);
    let timer = null;
    const loadPending = async () => {
      if (!store.getters['auth/isLoggedIn']) return;
      const [adj, pool] = await Promise.allSettled([api.get('tx/v1/adjustments'), api.get('exchange/v1/admin/pool/pending')]);
      // «Узгодження» queues (tx-proxy) plus the liquidity pool's withdrawal requests (exchange-svc)
      const total = (adj.status === 'fulfilled' ? adj.value.data?.total || 0 : 0) + (pool.status === 'fulfilled' ? pool.value.data?.pending || 0 : 0);
      if (adj.status === 'fulfilled' || pool.status === 'fulfilled') pendingTotal.value = total;
    };
    onMounted(() => {
      loadPending();
      timer = setInterval(loadPending, 60000);
    });
    onBeforeUnmount(() => clearInterval(timer));

    return {
      isRealEstateRoute,
      isRealEstate,
      isContractRoute,
      isNotariesRoute,
      isNotaryCabinetRoute,
      isWalletRecoveryRoute,
      isWalletRoute,
      isWallet,
      isCoordinationRoute,
      isDaoRoute,
      isExchangeRoute,
      vueRoutes,
      isDashboardRoute,
      pendingTotal,
    };
  },
};
</script>

<style lang="scss" scoped>
.nav-bar__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  height: 2rem;
  padding: 0 0.6rem;
  margin-left: auto;
  border-radius: 1rem;
  background: #e53e3e;
  color: #fff;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1;
}

@import '../../../scss/variables';
@import '../../../scss/mixins';

.nav-bar {
  &__nav-link {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 1.5rem 0;
    padding: 0 2.5rem;

    & svg {
      fill: $col-link;
    }
    & span {
      color: $col-link;
      font-size: 1.6rem;
      font-weight: 500;
      padding-left: 1.5rem;
    }

    &.active {
      border-left: $nav-active-border;
      padding: 0 2rem;

      & svg {
        fill: $col-link-active;
      }
      & span {
        color: $col-link-active;
      }
    }
  }
  &__nav-link-active {
    border-left: $nav-active-border;
    padding: 0 2rem;
    & svg {
      fill: $col-link-active;
    }
    & span {
      color: $col-link-active;
    }
  }
}
</style>
